<template>
  <div class="loading">
    <img src="~@/assets/img/loading.svg" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loading {
  @apply z-10 absolute flex items-center justify-center h-full w-full bg-gray-50;
}

img {
  @apply w-10;
}
</style>
